<template>
    <div id="detial_new" v-loading="pageLoading">

        <el-card class="box-card" style="margin-bottom:20px;font-size:14px">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/questionQueryNew' }">试题答疑</el-breadcrumb-item>
                <el-breadcrumb-item>问题详情</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <div class="main">
            <div class="contant-left">
                <div>
                    <div class="title">
                        <span style="float:left">提问人:{{question.userName||""}}</span>
                        <span style="float:right">提问时间:{{question.createTime}}</span>
                    </div>
                    <div class="title">
                        <span>科目课程:</span>
                        <span>{{question.courseName}}</span>
                      </div>
                    <div class="title">问题描述:</div>
                    <div class="question-title" style="font-size:14px;" v-html="question.questionsContent"></div>
                    <div v-if="question.answer">
                        <span class="title">老师回复：</span>
                        <span  class="mb20" v-html="question.answer"></span>
                    </div>
                    <div v-if="question.list">
                        <div v-for="item in question.list">
                            <div v-if="item.questionsContent">
                                <span class="title">继续追问:</span>
                                 <span class="mb20" v-html="item.questionsContent"></span>
                            </div>
                            <div v-if="item.answer">
                                <span class="title">老师回复:</span>
                                <span class="mb20" v-html="item.answer"></span>
                            </div>
                        </div>
                    </div>

                    <quill-editor v-if="unsolved == 1" ref="quillEditor" v-model="content" class="myQuillEditor"
                                  :options="editorOption"/>

                    <div style="margin-top:20px;" v-if="unsolved == 1">

                        <el-button v-auth="'/queryDetialNew/replyQuestionQuery'" @click="replyQuestionQuery" type="primary">提交</el-button>
                    </div>
                </div>
            </div>

            <div class="contant-right" v-if="showRight">
                <div class="item">
                    <el-button v-auth="'/queryDetialNew/updateQuestion'" type="primary" @click="updateQuestion">编辑试题</el-button>
                </div>
                <div class="item">
                    <div class="title">{{questionDetial.questionTypeName||""}} | {{question.questionPropertyName}}</div>
                    <div class="ptitle" v-if="questionDetial.ptitle" v-html="questionDetial.ptitle"></div>
                    <div v-if="questionDetial.optionList">
                        <div class="question-title" v-html="questionDetial.title"></div>
                        <div
                                v-for="(item,index) in questionDetial.optionList "
                                :key="index"
                                class="question-contant"
                        >{{item.options}}、<span v-html="item.name"></span></div>
                    </div>
                    <div v-else>
                        <div class="question-title" v-html="questionDetial.title"></div>
                    </div>
                </div>
                <div class="item" style="margin-top:20px;">
                    <div class="title">试题答案</div>
                    <div class="question-title" v-html="questionDetial.answer"></div>
                    <div class="title">试题解析</div>
                    <div class="question-title" style="font-size:12px;" v-html="questionDetial.analysis"></div>
                    <div class="title">视频/音频</div>
                    <div v-if="questionDetial.videoPath">
                        <video
                                style="max-height: 400px;width: auto;"
                                controls
                                preload="auto"
                                oncontextmenu="return false"
                                :src="questionDetial.videoPath"
                                v-if="questionDetial.videoPath?questionDetial.videoPath.indexOf('mp4')>-1:false"
                        ></video>
                        <audio
                                style="margin-top:20px;"
                                :src="questionDetial.videoPath"
                                controls="controls"
                                v-if="questionDetial.videoPath?questionDetial.videoPath.indexOf('mp3')>-1:false"
                        ></audio>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {quillEditor} from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillConfig from '../../upload/quill-config'
    import {ImageDrop} from 'quill-image-drop-module'
    import ImageResize from 'quill-image-resize-module'

    Quill.register('modules/imageDrop', ImageDrop);
    Quill.register('modules/imageResize', ImageResize);
    export default {
        components: {
            quillEditor,
            quillConfig
        },
        data() {
            return {
                question: {},
                showRight: false,
                pageLoading: false,
                questionDetial: {},
                answer: {
                    reply: "",
                    replyUser: ""
                },
                questionId: "",
                questionType: "",
                createTime: "",
                content: '',
                editorOption: quillConfig,
                unsolved: '',
                chatRecords:[]
            };
        },
        created() {
        },
        watch: {
            questionId() {
                this.question = {};
                this.showRight = false;
                this.questionDetial = {};
                this.answer = {
                    reply: "",
                    replyUser: ""
                };
                this.questionQueryInfo();
            }
        },
        mounted() {
            this.questionId = this.$route.query.id;
            this.questionType = this.$route.query.type;
            this.unsolved = this.$route.query.unsolved;
            this.questionQueryInfo();
        },
        methods: {
            //编辑试题
            updateQuestion() {
                if (this.questionDetial.big == 1) {
                    this.$router.push({
                        path: "/addCpQuestion",
                        query: {
                            upId: this.questionDetial.id,
                            idsss: this.questionId
                        }
                    });
                } else {
                    this.$router.push({
                        path: "/addQuestion",
                        query: {
                            upId: this.questionDetial.id,
                            upPid: this.questionDetial.pid,
                            idsss: this.questionId
                        }
                    });
                }
            },


            //回复问题 提交
            replyQuestionQuery() {
                let questionId= '';
                if(this.question.list != ''){

                    questionId = this.question.list[this.question.list.length-1].id;

                }else {
                    questionId = this.question.id;
                }

                let param = {
                    //问题的id
                    id: questionId,

                    answer: this.content,
                };

                if (this.$refs.quillEditor.value) {
                    this.api.questionQuery
                            .answer(param)
                            .then(result => {
                                if (result.success) {
                                    this.$message.success(result.message);
                                    console.log(result);
                                    this.$router.push({
                                        path: "/questionQueryNew",
                                    });
                                } else {
                                    this.$message.error(result.message);
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            });
                }


            },
            //问题详情
            questionQueryInfo() {
                this.pageLoading = true;
                let param = {
                    id: this.questionId
                };
                this.api.questionQuery
                        .getQuestionAnswering(param)
                        .then(result => {
                            this.pageLoading = false;
                            if (result.success) {
                                this.question = result.data;

                                if(this.questionType == 1){
                                    result.data.question.title = result.data.question.title
                                            .replace(
                                                    result.data.question.title ? /&(?!#?\w+;)/g : /&/g,
                                                    "&amp;"
                                            )
                                            .replace(/&lt;/g, "<")
                                            .replace(/&gt;/g, ">")
                                            .replace(/&quot;/g, '"')
                                            .replace(/&#39;/g, "'");
                                    this.questionDetial = result.data.question;
                                    this.showRight = true;
                                }


                            } else {
                                this.question = {};
                                this.questionDetial = {};
                                this.$message.error(result.message);
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
            }
        }
    };
</script>

<style lang="less" rel="stylesheet/less">
    #detial_new {
        width: 100%;
        .main {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            .contant-left {
                background: #fff;
                border-radius: 4px;
                padding: 10px;
                width: calc(60% - 40px);
                .title {
                    margin-bottom: 10px;
                    font-weight: bolder;
                    font-style: normal;
                    overflow: hidden;
                    font-size: 14px;
                    white-space: nowrap;
                    & > span {
                        padding: 10px 0;
                        font-size: 14px;

                    }

                }
                .question-title {
                    font-size: 14px;
                    color: #9b9b9b;
                    text-align: left;
                    margin-bottom: 14px;
                    line-height: 28px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .imag-list {
                    img {
                        width: 100px;
                        height: 100px;
                        margin-right: 20px;

                    }
                }
                .ql-container.ql-snow {
                    min-height: 200px;
                }

            }
            .contant-right {
                width: 40%;
                .item {
                    .ptitle {
                        font-size: 16px;
                        color: #455a64;
                        text-align: left;
                        margin-bottom: 14px;
                        line-height: 28px;
                        background: #f2f5f8;
                    }
                    border-radius: 4px;
                    background: #fff;
                    padding: 10px;

                    .title {
                        font-weight: 400;
                        font-style: normal;
                        color: #a2aabc;
                        line-height: 13px;
                        font-size: 12px;
                        margin-bottom: 20px;
                    }
                    .question-title {
                        font-size: 16px;
                        color: #455a64;
                        text-align: left;
                        margin-bottom: 14px;
                        line-height: 28px;
                    }
                    .question-contant {
                        font-size: 16px;
                        color: #455a64;
                        text-align: left;
                        line-height: 28px;
                        p {
                            display: inline;
                        }
                    }
                }
            }
        }
        .re {
            color: rgb(255, 117, 107);
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/questionQueryNew/queryDetialNew.vue